import * as React from 'react';
import RectImgBox from './BrotherCard';
import './BrotherCard.css';

import Stack from '@mui/material/Stack';

//Omicron class
import Akemi_Zollinger from '../../media/Brothers/Headshots/Omicron/Akemi_Zollinger.JPG';
import Celine_Chen from '../../media/Brothers/Headshots/Omicron/Celine_Chen.JPG';
import Courtney_Lee from '../../media/Brothers/Headshots/Omicron/Courtney_Lee.JPG';
import David_Li from '../../media/Brothers/Headshots/Omicron/David_Li.JPG';
import David_Ospina from '../../media/Brothers/Headshots/Omicron/David_Ospina.jpg';
import Emily_Dang from '../../media/Brothers/Headshots/Omicron/Emily_Dang.jpeg';
import Eric_Chen from '../../media/Brothers/Headshots/Omicron/Eric_Chen.JPG';
import Jared_Rei_Solis from '../../media/Brothers/Headshots/Omicron/Jared_Rei_Solis.JPG';
import Jason_Jiang from '../../media/Brothers/Headshots/Omicron/Jason_Jiang.JPG';
import Jilin_Zheng from '../../media/Brothers/Headshots/Omicron/Jilin_Zheng.JPG';
import Kacper_Bazan from '../../media/Brothers/Headshots/Omicron/Kacper_Bazan.JPG';
import Sienna_Chien from '../../media/Brothers/Headshots/Omicron/Sienna_Chien.JPG';


const Omicron = () => {
  const omicronClass = [
    {broname: "Akemi Zollinger", src: Akemi_Zollinger, alt: "Akemi Zollinger", majorGrad: "Mechanical Engineering '26"},
    {broname: "Celine Chen", src: Celine_Chen, alt: "Celine Chen", majorGrad: "Computer Engineering '25"},
    {broname: "Courtney Lee", src: Courtney_Lee, alt: "Courtney Lee", majorGrad: "Mechanical Engineering '24"},
    {broname: "David Li", src: David_Li, alt: "David Li", majorGrad: "Computer Engineering '25"},
    {broname: "David Ospina", src: David_Ospina, alt: "David Ospina", majorGrad: "Electrical Engineering '24"},
    {broname: "Emily Dang", src: Emily_Dang, alt: "Emily Dang", majorGrad: "Biomedical Engineering '25"},
    {broname: "Eric Chen", src: Eric_Chen, alt: "Eric Chen", majorGrad: "Computer Engineering '25"},
    {broname: "Jared Rei Solis", src: Jared_Rei_Solis, alt: "Jared Solis", majorGrad: "Computer Engineering '25"},
    {broname: "Jason Jiang", src: Jason_Jiang, alt: "Jason Jiang", majorGrad: "Computer Engineering '26"},
    {broname: "Jilin Zheng", src: Jilin_Zheng, alt: "Jilin Zheng", majorGrad: "Computer Engineering '26"},
    {broname: "Kacper Bazan", src: Kacper_Bazan, alt: "Kacper Bazan", majorGrad: "Mechanical Engineering '25"},
    {broname: "Sienna Chien", src: Sienna_Chien, alt: "Sienna Chien", majorGrad: "Computer Engineering '26"},
  ];
  return (
    <div className = "Classes">
      {omicronClass.map((photo, index) => (
        <RectImgBox
        key = {index}
        broname = {photo.broname}
        src = {photo.src}
        alt = {photo.alt}
        majorGrad = {photo.majorGrad}
        />
      ))}
    </div>
  );
};

export default Omicron;